import { RootState } from 'lib/centralStore';
import { createSelector } from '@reduxjs/toolkit';
import { VideoStreamingMode } from 'features/live/liveVideoStreaming';
import { initialBoundingRect } from './type';
import { shallowEqual } from 'fast-equals';

const _self = (state: RootState) => state.settings;

export const selectStreamingMode = createSelector(_self, (state) => state.streamingMode);
export const selectIsStreamingOpen = createSelector(
  [selectStreamingMode],
  (mode) => (mode ?? VideoStreamingMode.off) !== VideoStreamingMode.off
);
export const selectIsVisualizzazioneEstesa = createSelector(_self, (state) => state.isVisualizzazioneEstesa);

export const selectBoundingRect = createSelector(
  _self,
  ({ boundingRect }) => ({ ...initialBoundingRect, ...boundingRect }),
  {
    memoizeOptions: { resultEqualityCheck: shallowEqual },
  }
);
export const selectBoundingRectSize = createSelector([selectBoundingRect], ({ width, height }) => ({ width, height }), {
  memoizeOptions: { resultEqualityCheck: shallowEqual },
});
export const selectBoundingRectPosition = createSelector([selectBoundingRect], ({ top, left }) => ({ top, left }), {
  memoizeOptions: { resultEqualityCheck: shallowEqual },
});
